module.exports = __webpack_public_path__ + "img/Girl_010009.8d9fa6c9.png";